<template>
  <v-row class="ma-1">
    <v-col md="12" cols="12">
      <v-toolbar class="" color="primary" dark flat>
        <v-toolbar-title>SHMÚ Stanice</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          solo-inverted
          flat
          hide-details
          v-model="filter"
          prepend-inner-icon="mdi-magnify"
          clearable
        />
        <v-btn @click="addStanica()" text>Pridať</v-btn>
      </v-toolbar>
    </v-col>
    <v-col md="12" cols="12">
      <v-data-table
        :headers="headers"
        :items="stanice"
        :items-per-page="10"
        sort-by="IDMB"
        :search="filter"
        class="elevation-1 clickableTable"
        @click:row="viewStanica($event)"
      >
      </v-data-table>
      <div class="text-right">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <download-excel
              :data="stanice"
              :fields="exportFields"
              class="exportXLS"
            >
              <v-icon v-on="on">mdi-microsoft-excel</v-icon>
            </download-excel>
          </template>
          <span>Export do xls</span>
        </v-tooltip>
      </div>
    </v-col>
    <stanica-detail
      ref="dialogStanica"
      @change="readStanice()"
      @delete="readStanice()"
    ></stanica-detail>
  </v-row>
</template>

<script>
import StanicaDetail from "../components/StanicaDetail.vue"
import DownloadExcel from "vue-json-excel"

export default {
  data: () => ({
    headers: [
      { text: "ID", align: "left", sortable: true, value: "ID" },
      { text: "Stanica", align: "left", sortable: true, value: "Stanica" },
      {
        text: "Lokality",
        align: "left",
        sortable: false,
        value: "LokalityStr"
      },
      { text: "Indikatív", align: "left", sortable: true, value: "Indik" },
      { text: "Poznámka", align: "left", sortable: false, value: "Poznamka" },
      {
        text: "Počet meraní",
        align: "right",
        sortable: true,
        value: "ZrazkyCount"
      }
    ],
    exportFields: {
      ID: "ID",
      Stanica: "Stanica",
      Lokality: "LokalityStr",
      Indikatív: "Indik",
      //Poznámka: "Poznamka",
      "Počet meraní": "ZrazkyCount"
    },
    stanice: [],
    filter: ""
  }),

  components: {
    StanicaDetail,
    DownloadExcel
  },

  methods: {
    readStanice: async function() {
      try {
        let response = await this.$axios.get("/r/stanice")
        if (response.status === 200) {
          this.stanice = response.data
          for (let i = 0; i < this.stanice.length; i++) {
            this.stanice[i].LokalityStr = this.stanice[i].Lokality.toString()
          }
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    addStanica: function() {
      this.$refs.dialogStanica.show({ ID: 0, LokalityIds: [] })
    },

    viewStanica: function(s) {
      this.$router.push({
        name: "stanica",
        params: { lokalitaId: "0", id: s.ID }
      })
    }
  },

  mounted: async function() {
    console.log("stanice mounted")
    await this.$store.dispatch("fetchme", this.$axios)
    this.readStanice()
  }
}
</script>
